import Conditional from '@core/blocks/edu-flow-2/components/Fields/ConditionalField';
import { type FieldComponent, type FieldType } from '@core/blocks/edu-flow-2/utils/fieldTypeDictionary';

import CalloutField from '../components/Fields/CalloutField';
import CheckboxField from '../components/Fields/CheckboxField';
import OptionGroupField from '../components/Fields/OptionGroupField';
import PhoneField from '../components/Fields/PhoneField';
import RadioField from '../components/Fields/RadioField';
import SecurityDisclaimerField from '../components/Fields/SecurityDisclaimer';
import SelectField from '../components/Fields/SelectField';
import TextField from '../components/Fields/TextField';
import ZipField from '../components/Fields/ZipField';

const fieldTypeDictionary = {
  zip: ZipField,
  phone: PhoneField,
  text: TextField,
  radio: RadioField,
  select: SelectField,
  checkbox: CheckboxField,
  callout: CalloutField,
  conditional: Conditional,
  optionGroup: OptionGroupField,
  securityDisclaimer: SecurityDisclaimerField,
};

export default fieldTypeDictionary as Record<FieldType, FieldComponent>;
